import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

/** Rein optische Sterne-Anzeige (Bewertungskarten, Zusammenfassungszeile) - siehe
 * StarPicker fuer die interaktive Eingabe-Variante im Bewertungsformular. */
export function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5" aria-label={`${rating} von 5 Sternen`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          className={cn("h-4 w-4", i < rating ? "fill-gold-text text-gold-text" : "fill-none text-muted-foreground/30")}
          aria-hidden="true"
        />
      ))}
    </div>
  );
}

/** Interaktive Sterne-Auswahl fuers Bewertungsformular (components/landing/review-form.tsx). */
export function StarPicker({ value, onChange }: { value: number; onChange: (rating: number) => void }) {
  return (
    <div className="flex items-center gap-1" role="radiogroup" aria-label="Bewertung in Sternen">
      {Array.from({ length: 5 }).map((_, i) => {
        const starValue = i + 1;
        return (
          <button
            key={i}
            type="button"
            role="radio"
            aria-checked={value === starValue}
            aria-label={`${starValue} von 5 Sternen`}
            onClick={() => onChange(starValue)}
            className="p-0.5"
          >
            <Star
              className={cn(
                "h-6 w-6 transition-colors",
                starValue <= value ? "fill-gold-text text-gold-text" : "fill-none text-muted-foreground/30",
              )}
            />
          </button>
        );
      })}
    </div>
  );
}
